import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import {
  BackgroundCandidate,
  CandidateInterviewWrapper,
  ContentWithInterviewWrapper,
  ImageEmpretecText,
  TextWithInterviewWrapper,
} from '../../pages/candidate-interview/candidate-interview-styled';
import Button from '../button';
import { LayoutCandidate } from '../layout-candidate';

export const CandidateWithInterview = ({
  interviewId,
  moduleId,
  settingsModule,
  isAdmAccess,
}) => {
  const { navigateTo } = Sebrae.useSebraeRouter();

  const pageSettings = React.useMemo(() => {
    const settingsMap = settingsModule?.settingsMap;

    const buttonColorConfigMap = {
      undefined: { color: '#25091A', borderColor: '#B62A7E' },
      1: {
        color: '#25091A',
        borderColor: '#B62A7E',
        value: 'QUERO INICIAR A ENTREVISTA DE SELEÇÃO',
        valueSmall: 'QUERO INICIAR A ENTREVISTA',
      },
      2: {
        color: settingsMap?.tertiaryColor,
        borderColor: settingsMap?.primaryColor,
        value: 'QUERO INICIAR O QUESTIONÁRIO DE SELEÇÃO',
        valueSmall: 'QUERO INICIAR O QUESTIONÁRIO',
      },
      3: {
        color: settingsMap?.tertiaryColor,
        borderColor: settingsMap?.primaryColor,
        value: 'QUERO INICIAR A ENTREVISTA DE SELEÇÃO',
        valueSmall: 'QUERO INICIAR A ENTREVISTA',
      },
    };

    return {
      primaryColor: settingsMap?.primaryColor,
      secondaryColor: settingsMap?.secondaryColor,
      empretecCandidateActor: settingsMap?.empretecCandidateActor,
      empretecGraphics: settingsMap?.empretecGraphics,
      buttonColorConfig: buttonColorConfigMap[moduleId],
      empretecCandidateTextImg: settingsMap?.empretecCandidateTextImg,
      empretecCandidateTextSummary: settingsMap?.empretecCandidateTextSummary,
      empretecCandidateTextTitle: settingsMap?.empretecCandidateTextTitle,
      empretecCandidateTextDescription:
        settingsMap?.empretecCandidateTextDescription,
    };
  }, [moduleId, settingsModule]);

  return (
    <LayoutCandidate pageSettings={pageSettings} moduleId={moduleId}>
      <BackgroundCandidate
        empretecCandidateActor={pageSettings.empretecCandidateActor}
        empretecGraphics={pageSettings.empretecGraphics}
      >
        <CandidateInterviewWrapper>
          <ImageEmpretecText
            key={pageSettings.empretecCandidateTextImg}
            imgTextHome={pageSettings.empretecCandidateTextImg}
          />
          <ContentWithInterviewWrapper>
            <TextWithInterviewWrapper isThin>
              <span
                dangerouslySetInnerHTML={{
                  __html: pageSettings.empretecCandidateTextSummary,
                }}
              ></span>
              <span>
                {pageSettings.empretecCandidateTextTitle && (
                  <strong>
                    {pageSettings.empretecCandidateTextTitle}
                    <br />
                  </strong>
                )}
                <span
                  dangerouslySetInnerHTML={{
                    __html: pageSettings.empretecCandidateTextDescription,
                  }}
                ></span>
              </span>
            </TextWithInterviewWrapper>

            <Button
              calback={() => {
                if (isAdmAccess) {
                  navigateTo(`/candidato/sobre-curso/id/${interviewId}`);
                } else {
                  navigateTo(`/candidato/sobre-curso`);
                }
              }}
              value={pageSettings?.buttonColorConfig.value}
              valueSmall={pageSettings?.buttonColorConfig.valueSmall}
              color={pageSettings?.buttonColorConfig.color}
              withBorder={true}
              borderColor={pageSettings.buttonColorConfig.borderColor}
            />
          </ContentWithInterviewWrapper>
        </CandidateInterviewWrapper>
      </BackgroundCandidate>
    </LayoutCandidate>
  );
};
